module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"searchProperty":"Chercher une propiété","createProperty":"Créer une propriété","town":"Commune","townLabel":"Commune","streetLabel":"Rue","street":"Rue","streetNumber":"Numéro de police","properties":"propriétés","folderNumber":"N° dossier","reset":"Réinitialiser","filter":"Filtrer","complianceSurveyOnly":"Enquête de conformité seule"}}')
  delete Component.options._Ctor
}
